/**
 * Вероятнее всего ошибка axios
 * @param {Error} error
 * @return {boolean}
 */
import { AxiosError } from 'axios';
import CustomAxiosError from '~/src/helpers/customAxiosError';

export function isAxiosError(error: unknown): error is AxiosError {
    if (error instanceof CustomAxiosError) {
        return true;
    }

    if (!(error instanceof Error)) {
        return false;
    }

    return 'config' in error && 'request' in error && 'response' in error;
}

export interface BaseErrorBody {
    code: string,
    message: string
}

export function isBaseErrorBody(data: any): data is BaseErrorBody {
    if (!(data instanceof Object)) {
        return false;
    }
    return 'code' in data && 'message' in data && typeof data.message === 'string';
}

